module.exports = __webpack_public_path__ + "img/on-the-way-rafiki.e5958df9.svg";